import { useState, useEffect } from 'react';
import Header from './include/header';
import Footer from './include/footer';
import LeftPanel from './include/LeftPanel';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from '../components/ui/toast';
import Global from '../APIConfig';
import axios from "axios";
import AuthUser from "../AuthUser";
import CopyToClipboard from 'react-copy-to-clipboard';
import {
    Package, Clock, PackageCheck, Plus, Search, KeyRound, Copy, PencilLine, Lock, PackageOpen
} from "lucide-react";

function CustomerDashboard() {
    let navigate = useNavigate();
    const { headers1, logout } = AuthUser();
    const [trackingnumber, setTrackingnumber] = useState('');
    const [customerDetail, setCustomerDetail] = useState('');
    const [totalshipment, setTotalshipment] = useState('');
    const [totalDeliveredshipment, setTotalDeliveredshipment] = useState('');
    const items = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        GetCustomerDetail();
        Get30DaysShipments();
        Get30DaysDeliveredShipments();
    }, []);

    const GetCustomerDetail = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'getFrontCutomerDetail',
            headers: headers1,
            data: {
                UniqueId: items.uniqueid
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data;
                    setCustomerDetail(data.value);
                }
                else {
                    setCustomerDetail('');
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    logout();
                    navigate('/');
                    window.location.reload();
                }
            });
    }
    const Trackingshipment = () => {
        if (trackingnumber != "") {
            navigate(`/ShipmentTracking/${trackingnumber}`);
        }
        else {
            toast.warn("Please Enter AWB No.");
        }
    }
    const Get30DaysShipments = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Getcustomer30DaysShipments',
            headers: headers1,
            data: {
                UniqueId: items.uniqueid,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data;
                    setTotalshipment(data.label);
                }
                else {
                    setTotalshipment(0);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    logout();
                    navigate('/');
                    window.location.reload();
                }
            });
    }

    const Get30DaysDeliveredShipments = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'GetCustomer30DaysDeliveredShipment',
            headers: headers1,
            data: {
                UniqueId: items.uniqueid,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data;
                    setTotalDeliveredshipment(data.label);
                }
                else {
                    setTotalDeliveredshipment(0);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    logout();
                    navigate('/');
                    window.location.reload();
                }
            });
    }

    const handlekey = () => {
        const userConfirmed = window.confirm("Do you want to proceed?");
        if (userConfirmed == true) {
            axios({
                method: 'post',
                url: Global.baseUrl + 'generateKey',
                headers: headers1,
                data: {
                    UniqueId: items.uniqueid
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        window.location.reload();
                    }
                    else {
                        toast.warning(response.data.message);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
        }
        else {

        }
    }

    const stats = [
        { icon: <Package size={22} />, label: 'Shipments', value: totalshipment, sub: 'Last 30 days' },
        { icon: <Clock size={22} />, label: 'Schedule pickups', value: 0, sub: 'Last 30 days' },
        { icon: <PackageCheck size={22} />, label: 'Delivered', value: totalDeliveredshipment, sub: 'Last 30 days' },
    ];

    const shortcuts = [
        { icon: <PackageOpen size={26} />, label: 'My Booking List', to: '/Shipmentlist/All' },
        { icon: <PencilLine size={26} />, label: 'Edit Profile', to: '/UpdateProfile' },
        { icon: <Lock size={26} />, label: 'Change Password', to: '/UpdatePassword' },
    ];

    const profileFields = [
        ['Full Name', customerDetail.name],
        ['Company Name', customerDetail.company],
        ['Email', customerDetail.email],
        ['Mobile', customerDetail.phone],
        ['Address', customerDetail.address],
        ['City', customerDetail.city],
        ['Country', customerDetail.country],
        ['Postal/Zip code', customerDetail.pincode],
    ];

    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <div className="px-dash-head">
                        <div>
                            <h2>Welcome back{items && items.name ? `, ${items.name}` : ''}</h2>
                            <p className="px-dash-head__sub">Manage your shipments, wallet and account.</p>
                        </div>
                        <div className="px-dash-head__actions">
                            {customerDetail.developer_onoff === 'Y' && (
                                <button className="px-btn px-btn--secondary" onClick={() => handlekey()}>
                                    <KeyRound size={16} /> Generate Key
                                </button>
                            )}
                            <a className="px-btn px-btn--primary" href="/Createshipment">
                                <Plus size={16} /> New Shipment
                            </a>
                        </div>
                    </div>

                    <div className="px-card px-dash-quick">
                        <div className="px-dash-quick__item">
                            <span className="px-dash-quick__label">New request</span>
                            <a className="px-btn px-btn--secondary" href="/Createshipment">
                                <Plus size={16} /> Add Shipment
                            </a>
                        </div>
                        <div className="px-dash-quick__sep"></div>
                        <div className="px-dash-quick__item px-dash-quick__grow">
                            <span className="px-dash-quick__label">Track a shipment</span>
                            <div className="px-track-box">
                                <input type="text" className="px-input" placeholder="AWB number"
                                    aria-label="AWB number" value={trackingnumber}
                                    onChange={(e) => setTrackingnumber(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === 'Enter') Trackingshipment(); }} />
                                <button className="px-btn px-btn--primary" onClick={() => Trackingshipment()}>
                                    <Search size={16} /> Track
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="px-stat-grid">
                        {stats.map((s, i) => (
                            <div className="px-card px-card--stat" key={i}>
                                <span className="px-stat__icon">{s.icon}</span>
                                <div>
                                    <div className="px-stat__value">{s.value}</div>
                                    <div className="px-stat__label">{s.label} · {s.sub}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="px-card">
                        <div className="px-card__head px-card__head--stack">
                            <span className="px-card__title">Company profile</span>
                            {customerDetail.developer_onoff === 'Y' && customerDetail.developer_id && (
                                <span className="px-devkey">
                                    <span className="px-mono">{customerDetail.developer_id}</span>
                                    <CopyToClipboard text={customerDetail.developer_id}
                                        onCopy={() => { toast.success(customerDetail.developer_id + ' Copied To Clipboard'); }}>
                                        <button className="px-devkey__copy" aria-label="Copy developer key"><Copy size={14} /></button>
                                    </CopyToClipboard>
                                </span>
                            )}
                        </div>
                        <div className="px-card__body">
                            <div className="px-kv">
                                {profileFields.map(([k, v], i) => (
                                    <div className="px-kv__item" key={i}>
                                        <div className="px-kv__label">{k}</div>
                                        <div className="px-kv__value">{v || '-'}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="px-shortcut-grid">
                        {shortcuts.map((s, i) => (
                            <a className="px-card px-shortcut" href={s.to} key={i} target="_blank" rel="noopener noreferrer">
                                <span className="px-shortcut__icon">{s.icon}</span>
                                <span className="px-shortcut__label">{s.label}</span>
                            </a>
                        ))}
                    </div>
                </div>
                <Footer />
            </main>
        </>
    );
}

export default CustomerDashboard;
